module.exports = __webpack_public_path__ + "img/emoji/heart.002af74a29e1e3bb36358316b14e6b7e.png";